var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85709 14.506C6.37009 12.646 4.59609 10.6 3.62709 9.45C3.32709 9.094 3.22909 8.833 3.17009 8.374C2.96809 6.802 2.86709 6.016 3.32809 5.508C3.78909 5 4.60409 5 6.23409 5H17.7661C19.3961 5 20.2111 5 20.6721 5.507C21.1331 6.015 21.0321 6.801 20.8301 8.373C20.7701 8.832 20.6721 9.093 20.3731 9.449C19.4031 10.601 17.6261 12.651 15.1331 14.514C15.0178 14.6037 14.9225 14.7165 14.8533 14.8451C14.7841 14.9737 14.7425 15.1154 14.7311 15.261C14.4841 17.992 14.2561 19.488 14.1141 20.244C13.8851 21.466 12.1541 22.201 11.2261 22.856C10.6741 23.246 10.0041 22.782 9.93309 22.178C9.66756 19.8765 9.44286 17.5705 9.25909 15.261C9.24882 15.114 9.20771 14.9708 9.13845 14.8407C9.06919 14.7106 8.97333 14.5966 8.85709 14.506Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.f3a50e7afae9645af9ae5341fd098f9f.svg";
export { ForwardRef as ReactComponent };